import type React from 'react';

/**
 * Smooth-scrolls to the element behind a same-page `#anchor` href, falling back
 * to the browser's default jump when the id isn't on the page (e.g. during a
 * prerendered first paint before hydration).
 */
export function scrollToSection(e: React.MouseEvent<HTMLAnchorElement>, href: string) {
  const el = document.getElementById(href.slice(1));
  if (el) {
    e.preventDefault();
    el.scrollIntoView({ behavior: 'smooth' });
  }
}
